import React from 'react';
import styled from 'styled-components';
const Caret = (props) => {
    return React.createElement(CaretWrapper, { ...props },
        React.createElement(CaretTip, { caretColor: props.caretColor }));
};
const CaretWrapper = styled.span `
    overflow: hidden;
   
    position: absolute;
    height: 11px;
    width: 38px;
`;
const CaretTip = styled("span") `
    position: absolute;
    width: 19px;
    height: 19px;
    top: 3px;
    left: 13px;
    
    background: ${props => props.caretColor || props.theme.colors.white};
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    border-radius: 3px;
`;
export default Caret;
//# sourceMappingURL=Caret.js.map